<div class="flex flex-col md:flex-row gap-6 min-h-0">
  <!-- ── CHAP: rasm + meta ── -->
  <div class="flex flex-col gap-4 md:w-[280px] shrink-0">
    <!-- Rasm -->
    <div
      class="relative rounded-2xl border border-gray-200 dark:border-gray-700 overflow-hidden bg-gray-50 dark:bg-gray-800 aspect-square w-full flex items-center justify-center group"
    >
      @if (product!.imageUrl) {
        <img [src]="product!.imageUrl" [alt]="product!.name" class="w-full h-full object-contain" />
        <button
          type="button"
          class="absolute top-3 right-3 w-8 h-8 rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 flex items-center justify-center shadow-sm opacity-0 group-hover:opacity-100 transition-opacity"
          (click)="imageZoom = true"
        >
          <i class="pi pi-search-plus text-sm text-gray-600 dark:text-gray-300"></i>
        </button>
      } @else {
        <i class="pi pi-box text-7xl text-gray-200 dark:text-gray-700"></i>
      }
    </div>

    <!-- Zoom dialog -->
    <p-dialog
      [(visible)]="imageZoom"
      [modal]="true"
      [header]="product!.name"
      [style]="{ width: 'min(560px, 95vw)' }"
      [draggable]="false"
      appendTo="body"
    >
      <div class="flex items-center justify-center p-2">
        <img
          [src]="product!.imageUrl"
          [alt]="product!.name"
          class="max-w-full max-h-[70vh] object-contain rounded-xl"
        />
      </div>
    </p-dialog>

    <!-- Meta jadval -->
    <div
      class="rounded-xl border border-gray-200 dark:border-gray-800 divide-y divide-gray-100 dark:divide-gray-800 overflow-hidden text-sm"
    >
      <div class="flex items-center gap-3 px-4 py-3">
        <span class="w-5 flex items-center justify-center shrink-0">
          <i class="pi pi-barcode text-gray-400 dark:text-gray-500"></i>
        </span>
        <span class="text-gray-500 dark:text-gray-400 shrink-0">{{
          'PRODUCTS.TABLE.BARCODE' | translate
        }}</span>
        <span class="ml-auto font-mono text-gray-800 dark:text-gray-200 truncate">{{
          product!.barcode || '—'
        }}</span>
        @if (product!.barcode) {
          <button
            type="button"
            class="shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
            (click)="copyBarcode(product!.barcode)"
            [title]="'COMMON.COPY' | translate"
          >
            <i class="pi pi-copy text-xs"></i>
          </button>
        }
      </div>

      <div class="flex items-center gap-3 px-4 py-3">
        <span class="w-5 flex items-center justify-center shrink-0">
          <i class="pi pi-tag text-gray-400 dark:text-gray-500"></i>
        </span>
        <span class="text-gray-500 dark:text-gray-400 shrink-0">{{
          'PRODUCTS.TABLE.CATEGORY' | translate
        }}</span>
        <span class="ml-auto text-gray-800 dark:text-gray-200 truncate">{{
          product!.categoryName || '—'
        }}</span>
      </div>

      <div class="flex items-center gap-3 px-4 py-3">
        <span class="w-5 flex items-center justify-center shrink-0">
          <i class="pi pi-box text-gray-400 dark:text-gray-500"></i>
        </span>
        <span class="text-gray-500 dark:text-gray-400 shrink-0">{{
          'PRODUCTS.TABLE.UNIT' | translate
        }}</span>
        <span class="ml-auto text-gray-800 dark:text-gray-200">{{
          product!.unitOfMeasureName || '—'
        }}</span>
      </div>

      @if (storeName !== null) {
        <div class="flex items-center gap-3 px-4 py-3">
          <span class="w-5 flex items-center justify-center shrink-0">
            <i class="pi pi-shop text-gray-400 dark:text-gray-500"></i>
          </span>
          <span class="text-gray-500 dark:text-gray-400 shrink-0">{{
            'PRODUCTS.TABLE.STORE' | translate
          }}</span>
          <span class="ml-auto text-gray-800 dark:text-gray-200 truncate">{{
            storeName || '—'
          }}</span>
        </div>
      }
    </div>

    @if (mode === 'view') {
      <p-button
        [label]="'PRODUCTS.EDIT_TOOLTIP' | translate"
        icon="pi pi-pencil"
        [outlined]="true"
        styleClass="w-full"
        (onClick)="requestEdit.emit(product!)"
      />
    }
  </div>

  <!-- ── O'NG: narx + variantlar + miqdor ── -->
  <div class="flex flex-col gap-4 flex-1 min-w-0">
    @if (loading()) {
      <div class="flex items-center justify-center py-20 text-gray-400">
        <i class="pi pi-spin pi-spinner text-3xl"></i>
      </div>
    } @else {
      <!-- Narx + ombor -->
      <div
        class="rounded-xl bg-emerald-50 dark:bg-emerald-950/30 border border-emerald-100 dark:border-emerald-900/40 px-5 py-4 flex items-center justify-between gap-4"
      >
        <div class="text-2xl font-bold text-gray-900 dark:text-gray-100">
          {{ effectivePrice() | money: product!.sellCurrency }}
          @if (!hasVariants() && product!.discount > 0) {
            <span
              class="ml-2 text-sm font-medium text-emerald-600 bg-emerald-100 dark:bg-emerald-900/50 dark:text-emerald-400 px-2 py-0.5 rounded-full"
            >
              -{{ product!.discount | money: product!.sellCurrency }}
            </span>
          }
        </div>
        <div
          class="flex items-center gap-2 shrink-0 text-sm font-medium text-emerald-700 dark:text-emerald-400 bg-emerald-100 dark:bg-emerald-900/50 px-3 py-1.5 rounded-lg"
        >
          <i class="pi pi-inbox text-base"></i>
          <span
            >{{ 'PRODUCTS.DETAIL.AVAILABLE' | translate }}: {{ effectiveStock() }}
            {{ product?.unitOfMeasureName || ('PRODUCTS.DETAIL.PCS' | translate) }}</span
          >
        </div>
      </div>

      <!-- Variantlar -->
      @if (hasVariants()) {
        @for (axis of matrix()!.attributes; track axis.attributeId) {
          <div class="space-y-2">
            <div class="text-sm font-semibold text-gray-700 dark:text-gray-300">
              {{ axis.attributeName }}
            </div>
            <div class="flex flex-wrap gap-2">
              @for (val of axis.values; track val.valueId) {
                @let selected = isVariantValueSelected(axis.attributeId, val.valueId);
                @let avail = isValueAvailable(axis.attributeId, val.valueId);
                <button
                  type="button"
                  [disabled]="!avail && !selected"
                  (click)="selectVariantValue(axis.attributeId, val.valueId)"
                  class="relative px-4 py-2 rounded-xl border-2 text-sm font-medium transition-all"
                  [ngClass]="
                    selected
                      ? 'border-emerald-500 bg-emerald-50 dark:bg-emerald-950/30 text-emerald-700 dark:text-emerald-300'
                      : avail
                        ? 'border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                        : 'border-gray-100 dark:border-gray-800 text-gray-300 dark:text-gray-600 line-through opacity-60 cursor-not-allowed'
                  "
                >
                  @if (selected) {
                    <span
                      class="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-emerald-500 flex items-center justify-center"
                    >
                      <i class="pi pi-check text-white text-[9px]"></i>
                    </span>
                  }
                  {{ val.value }}
                </button>
              }
            </div>
          </div>
        }

        <!-- Tanlangan variant xulosa satri -->
        <div
          class="rounded-xl border px-4 py-3 flex items-center justify-between gap-4 text-sm"
          [ngClass]="
            selectedVariant()
              ? 'border-emerald-200 dark:border-emerald-900/50 bg-emerald-50/60 dark:bg-emerald-950/20'
              : 'border-dashed border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50'
          "
        >
          @if (selectedVariant(); as v) {
            <div class="flex items-center gap-2 text-gray-700 dark:text-gray-300">
              <i class="pi pi-check-circle text-emerald-500"></i>
              <span
                >{{ 'PRODUCTS.DETAIL.SELECTED' | translate }}:
                <strong>{{ variantLabel(v) }}</strong>
              </span>
            </div>
            <span
              class="shrink-0 font-semibold"
              [ngClass]="
                (v.stock ?? 0) <= 0 ? 'text-red-500' : 'text-emerald-600 dark:text-emerald-400'
              "
            >
              {{ 'PRODUCTS.DETAIL.REMAINING' | translate }}: {{ v.stock ?? 0 }}
              {{ 'PRODUCTS.DETAIL.PCS' | translate }}
            </span>
          }
        </div>
      }

      <!-- Sale mode: miqdor + savatga qo'shish -->
      @if (mode === 'sale') {
        @if (!canPickQuantity()) {
          <!-- Variant tanlanmagan — miqdor kiritib bo'lmaydi -->
          <div
            class="rounded-xl border border-dashed border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 px-4 py-3 text-sm text-gray-400 dark:text-gray-500 text-center"
          >
            {{ 'PRODUCTS.DETAIL.PICK_COMBO' | translate }}
          </div>
        } @else if (effectiveStock() <= 0) {
          <div
            class="rounded-xl border border-red-200 dark:border-red-900/40 bg-red-50 dark:bg-red-950/20 px-4 py-3 text-sm text-red-600 dark:text-red-400 text-center"
          >
            {{ 'SALES.OUT_OF_STOCK' | translate }}
          </div>
        } @else {
          <div class="space-y-3">
            <!-- Miqdor -->
            <div>
              <div class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                {{ 'PRODUCTS.DETAIL.QUANTITY' | translate }}
              </div>
              <div
                class="flex items-center gap-0 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden w-fit"
              >
                <button
                  type="button"
                  class="w-11 h-11 flex items-center justify-center text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-lg font-semibold disabled:opacity-30"
                  [disabled]="quantity() <= 1"
                  (click)="decreaseQty()"
                >
                  −
                </button>
                <span
                  class="w-14 text-center font-bold text-gray-900 dark:text-gray-100 text-lg border-x border-gray-200 dark:border-gray-700 py-2 select-none"
                >
                  {{ quantity() }}
                </span>
                <button
                  type="button"
                  class="w-11 h-11 flex items-center justify-center text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-lg font-semibold disabled:opacity-30"
                  [disabled]="quantity() >= effectiveStock()"
                  (click)="increaseQty()"
                >
                  +
                </button>
              </div>
            </div>

            <!-- Jami + Savatga -->
            <div
              class="flex rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden"
            >
              <div class="flex items-center justify-between flex-1 px-4 py-3 gap-3">
                <span class="text-sm font-medium text-gray-500 dark:text-gray-400 shrink-0">{{
                  'SALES.TOTAL' | translate
                }}</span>
                <span class="font-bold text-gray-900 dark:text-gray-100 text-base">
                  {{ effectivePrice() * quantity() | money: product!.sellCurrency }}
                </span>
              </div>
              <button
                type="button"
                class="flex items-center gap-2 px-5 py-3 bg-emerald-600 hover:bg-emerald-700 active:scale-95 text-white font-semibold text-sm transition-all disabled:opacity-40 disabled:cursor-not-allowed shrink-0"
                [disabled]="!canAddToCart()"
                (click)="onAddToCart()"
              >
                <i class="pi pi-shopping-cart"></i>
                {{ 'SALES.ADD_TO_CART' | translate }}
              </button>
            </div>
          </div>
        }
      }
    }
  </div>
</div>
